import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/student/teacher-list`;

export const teacherListRoutesObj = {
  list: baseRoute,
  view: `${baseRoute}/view/:teacherId`,
} as const;

export type ITeacherListRouteParams = IExtractRouteParamMap<
  typeof teacherListRoutesObj
>;

export const teacherListPath = createPaths<
  typeof teacherListRoutesObj,
  ITeacherListRouteParams
>(teacherListRoutesObj);
